/* KOLI: 1注文の上限を強制する（2026-09-04 ユーザー決定＝30個）。
   HTMLの max 属性は「+ボタン」の上限にしか効かず、手入力・cart/add.js直叩きでは破れる。
   ここでフロントの数量入力を30に丸め、さらにカートに既に30超が入っていたら是正する。
   最終防波堤は送料設定（30個ぶん＝0.54kg超で「配送方法なし」）。両者の二段構え。
   商品が増えたら商品別上限に作り替える（現状1SKU運用）。 */
(function () {
  var MAX = 30;
  var SEL = '.quantity__input, input[name^="updates"]';

  function clamp(el) {
    if (!el) return;
    var v = parseInt(el.value, 10);
    if (!isNaN(v) && v > MAX) {
      el.value = MAX;
      el.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  ['input', 'change'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var t = e.target;
      if (t && t.matches && t.matches(SEL)) clamp(t);
    }, true);
  });

  // 既にカートに上限超が入っている場合の是正（カートページで1回だけ）
  function fixCart() {
    if (location.pathname.indexOf('/cart') !== 0) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var over = (cart.items || []).filter(function (it) { return it.quantity > MAX; });
        if (over.length === 0) return;
        // 先頭の1件を直して再読込（複数あっても再読込後に再度是正される）
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: over[0].key, quantity: MAX })
        }).then(function () { location.reload(); });
      })
      .catch(function () { /* 失敗しても送料バックストップが効くので握りつぶす */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixCart);
  } else {
    fixCart();
  }
})();
